import { createApp } from 'vue'
import './style.css'
// Vue: Could not find a declaration file for module ./App.vue.
// c:/Users/bbcha_cyp1805/PhpstormProjects/game_admin/src/App.vue
// implicitly has an any type.
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'
import AdminApiClient from "./utils/admin-api-client.ts";


const app = createApp(App)

// Create a global API client instance
app.config.globalProperties.$api = new AdminApiClient()

app.use(createPinia())
app.use(router)

app.mount('#app')